const DeliveryType = {
  EMAIL_THEN_SMS: 0,
  SMS_THEN_EMAIL: 1
};

const DeliveryTypeLabel = {
  0 : 'Email',
  1 : 'SMS'
};

export { DeliveryType, DeliveryTypeLabel };
